import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fefb8d6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "small" }
const _hoisted_3 = { class: "float-right-total" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Endereço:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Número:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Complemento:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Referência: ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Bairro: ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Cidade: ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "UF: ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "CEP: ", -1))
const _hoisted_12 = { key: 0 }

import { IonHeader, 
        IonToolbar,
        IonIcon,
        IonTitle,
        IonBadge ,
        IonPage, 
        IonList, 
        IonItem, 
        IonThumbnail, 
        IonLabel, 
        IonContent ,
        IonGrid, 
        IonRow, 
        IonCol,
        IonCard,
        IonCardHeader,
        IonCardTitle,
        IonCardSubtitle,
        IonCardContent,
        IonDatetime,
        IonButton,
        IonSelect,
        IonInput, 
        IonSelectOption,
        alertController 
        } from '@ionic/vue';
import { useStore } from 'vuex';
import { cart , arrowBackOutline } from 'ionicons/icons';
import { reactive, ref, computed, onMounted, onUpdated } from 'vue';
import { key } from '../store/index';
import moment from 'moment';
import router from '@/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutFinal',
  setup(__props) {

const store = useStore(key);

let cartdata = reactive(store.state.cart);
const cartitemnum = ref(store.state.cart.length);

const user = reactive(store.state.user)

const totalCart  = computed(()=>{
    return (store.state.totalcart).toFixed(2).replace('.',',');
});

// const datahoraagora = ref();
// const datamaxima = ref();


const datenow = moment().utc(3).add(2, 'h').toISOString().replace(/.\d+Z$/g, "Z");
const datamin = moment().utc(3).add(3, 'h').toISOString().replace(/.\d+Z$/g, "Z");
const datemax = moment().utc(3).add(1, 'd').toISOString().replace(/.\d+Z$/g, "Z");

// datahoraagora.value = moment.ISO_8601(yourDate);
const datahoraagora = ref(datenow.toString());
const datamaxima = ref(datemax.toString());
const dataminima = ref(datamin.toString());

const agendamento = ref('RAPIDO');
const dataagenda = ref('');
const formadepagamento = ref('');
const valortroco = ref();

// onActivated(()=>{
//     console.log('mounted final')
//     cartdata = store.state.cart;
//     cartitemnum.value = store.state.cart.length;
// })

onMounted(()=>{
    cartdata = store.state.cart;
})

onUpdated(() => {
    cartdata = store.state.cart;
})

const userForAddress = computed(()=>{
    if (store.state.user.length > 2){
        const us = store.state.user;
        const indexuseradd = store.state.user.length -1;
        console.log(us[indexuseradd]);
        return us[indexuseradd];
    } else {
        const us = store.state.user;
        // const indexuseradd = store.state.user.length -1;
        console.log(us[0], us[1]);
        return us[1];
    }
})

//console.log('dm', dataminima.value)
function upper(txt: string){
    return txt.toUpperCase();
}
function numberPreco(preco: number){
    const prc: string = preco.toFixed(2).toString();
    return prc.replace(".", ",");
    // return preco;
}
const presentAlert = async () => {
    const alert = await alertController.create({
        header: 'Alerta',
        subHeader: 'Digitar o valor do troco',
        message: 'Você precisa digitar o valor do troco para dinheiro!',
        buttons: ['OK'],
    });

    await alert.present();
};

const presentAlertSemPagamento = async () => {
const alert = await alertController.create({
    header: 'Alerta',
    subHeader: 'Escolha uma forma de pagamento',
    message: 'Você precisa escolher uma forma de pagamento para o seu pedido!',
    buttons: ['OK'],
});

await alert.present();
};


function confirmarPedido(){ 
    let dadosfinal: any = {};
    if (formadepagamento.value == 'DINHEIRO' && valortroco.value == ''){
        presentAlert();
        return;
    }
    if (formadepagamento.value == '' || valortroco.value == ''){
        presentAlertSemPagamento();
        return;
    }
    if(dataagenda.value == ''){
        dadosfinal = {
            datarealizadopedido: datenow,
            agendamentopedido: datamin,
            pagamento: formadepagamento.value,
            troco: valortroco.value
        };
        
    } else {
        dadosfinal = {
            datarealizadopedido: datenow,
            agendamentopedido: dataagenda.value,
            pagamento: formadepagamento.value,
            troco: valortroco.value,
        };
    }
    //console.log('dh ' ,dataehorarios);
    store.dispatch('confirmaPedido', dadosfinal);
    setTimeout(()=>{
        router.push('/thankyou');
    }, 500);
}

function alterarPedido(){
    router.push('/tabs/carrinho')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), { color: "danger" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                icon: _unref(arrowBackOutline),
                slot: "start",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack()))
              }, null, 8, ["icon"]),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("Checkout Uniboi")
                ]),
                _: 1
              }),
              _createVNode(_unref(IonIcon), {
                collapse: true,
                slot: "end",
                icon: _unref(cart),
                onClick: _cache[1] || (_cache[1] = () => _unref(router).push('/tabs/carrinho'))
              }, null, 8, ["icon"]),
              _createVNode(_unref(IonBadge), {
                color: "dark",
                slot: "end"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(cartitemnum.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonGrid), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCard), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonCardHeader), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonCardTitle), null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Pedido")
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(IonCardSubtitle), null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Confira todos os dados do seu pedido:")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonCardContent), null, {
                            default: _withCtx(() => [
                              (_unref(cartdata).length > 0)
                                ? (_openBlock(), _createBlock(_unref(IonList), { key: 0 }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cartdata), (itemcart, index) => {
                                        return (_openBlock(), _createBlock(_unref(IonItem), { key: index }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(IonThumbnail), { slot: "start" }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("img", {
                                                  alt: "image",
                                                  src: itemcart.cloud_image_url
                                                }, null, 8, _hoisted_1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_unref(IonLabel), null, {
                                              default: _withCtx(() => [
                                                _createElementVNode("h3", null, _toDisplayString(upper(itemcart.nome)), 1),
                                                _createElementVNode("p", null, _toDisplayString(upper(itemcart.pdescricao)), 1),
                                                _createElementVNode("p", null, "Quant: " + _toDisplayString(itemcart.quantItem), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_unref(IonLabel), { slot: "end" }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("p", _hoisted_2, "R$ " + _toDisplayString(numberPreco(itemcart.totalitem)), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128)),
                                      _createVNode(_unref(IonItem), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(IonLabel), {
                                            slot: "start",
                                            class: "mini"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Taxa de entrega")
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_unref(IonLabel), {
                                            slot: "end",
                                            class: "mini"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("R$ 0,00")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createElementVNode("p", _hoisted_3, "Total Pedido: R$ " + _toDisplayString(_unref(totalCart)), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCard), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonCardHeader), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonCardTitle), null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Endereço de entrega")
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(IonCardSubtitle), null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Confira o endereço de entrega")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonCardContent), null, {
                            default: _withCtx(() => [
                              _createElementVNode("p", null, [
                                _hoisted_4,
                                _createTextVNode(" " + _toDisplayString(_unref(userForAddress)?.endereco), 1)
                              ]),
                              _createElementVNode("p", null, [
                                _hoisted_5,
                                _createTextVNode(" " + _toDisplayString(_unref(userForAddress)?.numero), 1)
                              ]),
                              _createElementVNode("p", null, [
                                _hoisted_6,
                                _createTextVNode(" " + _toDisplayString(_unref(userForAddress)?.complemento), 1)
                              ]),
                              _createElementVNode("p", null, [
                                _hoisted_7,
                                _createTextVNode(_toDisplayString(_unref(userForAddress)?.referencia), 1)
                              ]),
                              _createElementVNode("p", null, [
                                _hoisted_8,
                                _createTextVNode(_toDisplayString(_unref(userForAddress)?.bairro) + " - ", 1),
                                _hoisted_9,
                                _createTextVNode(_toDisplayString(_unref(userForAddress)?.cidade) + " - ", 1),
                                _hoisted_10,
                                _createTextVNode(_toDisplayString(_unref(userForAddress)?.uf), 1)
                              ]),
                              _createElementVNode("p", null, [
                                _hoisted_11,
                                _createTextVNode(_toDisplayString(_unref(userForAddress)?.cep?.substring(0,5)) + "-" + _toDisplayString(_unref(userForAddress)?.cep?.substring(5,)), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCard), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonCardHeader), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonCardTitle), null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Entrega do pedido")
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(IonCardSubtitle), null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Quando você quer receber o pedido")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonCardContent), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonSelect), {
                                placeholder: "selecionar agendamento",
                                modelValue: agendamento.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((agendamento).value = $event))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonSelectOption), { value: "RAPIDO" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Receber rápido (á partir de 1h)")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCard), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonCardHeader), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonCardTitle), null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Formas de pagamento")
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(IonCardSubtitle), null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Selecione a forma de pagamento")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonCardContent), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonSelect), {
                                placeholder: "Forma de pagamento",
                                modelValue: formadepagamento.value,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formadepagamento).value = $event))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonSelectOption), { value: "DINHEIRO" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Dinheiro")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(IonSelectOption), { value: "CREDITO" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Cartão de Crédito")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(IonSelectOption), { value: "DEBITO" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Cartão de Débito")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(IonSelectOption), { value: "PIX" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("PIX")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              (formadepagamento.value == 'DINHEIRO')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createVNode(_unref(IonLabel), { position: "fixed" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Troco para (valor em dinheiro para troco)")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(IonInput), {
                                      modelValue: valortroco.value,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((valortroco).value = $event)),
                                      placeholder: "R$",
                                      type: "number",
                                      inputmode: "numeric"
                                    }, null, 8, ["modelValue"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonButton), {
                        color: "danger",
                        expand: "block",
                        size: "large",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (confirmarPedido()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Confirmar o meu pedido")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonButton), {
                        color: "medium",
                        expand: "block",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (alterarPedido()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Alterar o meu pedido")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})